<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Financial Expertises</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateFinancialExpertise()">
        <mat-icon>add</mat-icon>
        Add Financial Expertise
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="financialExpertises()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditFinancialExpertise($event)"
      (deleteClick)="onDeleteFinancialExpertise($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
